import React from 'react'
import useSeti from '@/hooks/useSeti'
import getSearchData from './helper/getSearchData'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import FlightRecentSearchWithBanner from './FlightRecentSearchWithBanner'
import FlightRecentSearchWithCheckbox from './FlightRecentSearchWithCheckbox'
import { MostRecentFlightSearches } from '../types'
import { fireFlightsOnContinueClickEvent } from '../GA4Helpers'

export default function FlightRecentSearchModule({
  mostRecentFlightSearchData
}: {
  mostRecentFlightSearchData: MostRecentFlightSearches
}) {
  const fightsLPTripActivityBundlesExperiment = useSeti(
    'FLIGHT_LP_TRIPACTIVITY_BUNDLES',
    false
  )

  const searchData = getSearchData(mostRecentFlightSearchData)

  const {
    flyTravelersCount,
    cabinClass,
    destinationCityCode,
    originCityCode,
    startDateShortFormat,
    endDateShortFormat
  } = searchData

  const packageSearchParams = {
    flyTravelersCount,
    cabinClass,
    destinationCityCode,
    originCityCode,
    startDateShortFormat,
    endDateShortFormat
  }

  const showBundleHugBanner =
    fightsLPTripActivityBundlesExperiment === 'BUNDLEHUG_BANNER' &&
    endDateShortFormat

  const showBundleHugCheckboxes =
    fightsLPTripActivityBundlesExperiment === 'BUNDLEHUG_CHECKBOXES' &&
    endDateShortFormat

  if (showBundleHugBanner) {
    return (
      <FlightRecentSearchWithBanner
        searchData={searchData}
        packageSearchParams={packageSearchParams}
      />
    )
  }

  if (showBundleHugCheckboxes) {
    return (
      <FlightRecentSearchWithCheckbox
        searchData={searchData}
        packageSearchParams={packageSearchParams}
      />
    )
  }

  return (
    <FlightsRecentSearchCard
      searchData={searchData}
      onContinueSearchClick={fireFlightsOnContinueClickEvent}
    />
  )
}
